<template>
  <div class="sub_search_wrap-contents_months">
    <div class="sub_search-contents_titwrap">
      <div class="sub_contents-tit">
        <span class="sub_contents_close" v-on:click="close()">×</span>
        <span class="sub_contents_tit_txt">開催時期</span>
        <span class="sub_contents_tit_clear"><a v-on:click="monthsStore.clear()">すべてクリア</a></span>
      </div>
    </div>

    <div class="sub_search-contents_months">
      <div class="sub_search-contents_table">
        <table class="m3-table m3-table-search-toggle">
          <tbody>
            <tr>
              <td class="subsearch-toggle-subb">
                <div class="checkbox" v-for="month in monthsStore.master">
                  <input
                    class="months css-checkbox"
                    type="checkbox"
                    v-model="checkboxValue"
                    :value="month"
                    :id="`month_${month}`">
                  <label :for="`month_${month}`" class="css-label m3p_mr5">&nbsp;{{ month }}月</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="sub_search-fixbtnbox">
      <ul class="sub_search-btn">
        <li><button type="submit" class="link_btn_green">検索する</button></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { setupModal } from '@component_path/lib/modal.js'
setupModal('.sub_search-contents_months')
const emit = defineEmits(['close'])

const monthsStore = inject('monthsStore')
const checkboxValue = computed({
  get: () => monthsStore.months.value,
  set: (value) => monthsStore.set(value)
})

const close = () => {
  monthsStore.reset()
  emit('close')
}
</script>
